module.exports = __webpack_public_path__ + "static/img/freight-null-data.21f6197c.png";